module.exports = __webpack_public_path__ + "img/title-signup@1x.6e43be7c.png";